'use client';
import clsx from 'clsx';
import React from 'react';
import { DsmColor } from '../../../../constants/colors.mjs';
import { ColorSwatch } from '../../../../Controls/ColorSwatch/ColorSwatch.mjs';
import { polymorphicFactory } from '../../../../factory/factory.utils.mjs';
import { Typography } from '../../../../Foundations/Typography/Typography.mjs';
import { Flex } from '../../../../Layout/Flex/Flex.mjs';
import { useMergedRef } from '../../../../Popover/subcomponents/Popover/PopoverTarget/use-merged-ref.mjs';
import classes from './ColorSwatches.module.css.mjs';
import { useColorSwatchesLayout } from './useColorSwatchesLayout.mjs';

const ColorSwatches = polymorphicFactory((props, ref) => {
  const { component = "div", colors, extraColors, selectedColor, onColorSelected, className, ...rest } = props;
  const { containerRef, sampleSwatchRef, hiddenPlusRef, visibleCount, computedExtra } = useColorSwatchesLayout(colors.length, extraColors);
  const mergedContainerRef = useMergedRef(containerRef, ref);
  const handleSelect = (color) => onColorSelected?.(selectedColor === color ? null : color);
  const first = colors[0];
  return /* @__PURE__ */ React.createElement(Flex, { gap: 5, align: "center", wrap: "wrap", ref: mergedContainerRef, className: clsx(className), component, ...rest }, first && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(
    ColorSwatch,
    {
      ref: sampleSwatchRef,
      className: classes.colorSwatchGroupColor,
      ...first,
      isSelected: selectedColor === first.colorName,
      onClick: () => handleSelect(first.colorName)
    }
  )), colors.slice(1, visibleCount).map((color) => /* @__PURE__ */ React.createElement(
    ColorSwatch,
    {
      key: color.colorName,
      className: classes.colorSwatchGroupColor,
      ...color,
      isSelected: selectedColor === color.colorName,
      onClick: () => handleSelect(color.colorName)
    }
  )), (computedExtra > 0 || Number(extraColors) > 0) && /* @__PURE__ */ React.createElement(Typography, { textColor: DsmColor.ContentTertiary, size: "label-regular-m", component: "span" }, "+", extraColors ?? computedExtra), /* @__PURE__ */ React.createElement(
    Typography,
    {
      ref: hiddenPlusRef,
      "aria-hidden": "true",
      size: "label-regular-m",
      component: "span",
      position: "absolute",
      whiteSpace: "nowrap",
      visibility: "hidden",
      style: { pointerEvents: "none" }
    },
    "+99"
  ));
});

export { ColorSwatches };
